/**
* @ngdoc directive
* @name Export To Pdf
*
* @description
  Export to pdf button.
  To make this feature work, you must use the following markup:
  * <table>...</table>
  * <table-view></table-view> directive
  * custom:
    - add js-export-th class to table headers
    - add js-export-tr class to table rows
    - add js-export-td class to table cells
    - set is-class-table-structure='true' in export-to-pdf
  * add js-export-report-name class to element with report name
  * add js-export-subtitle class to element with report subtitle
*
* @scope
* @param {Boolean} isDisabled - disable button
* @param {Number} alignCenter - optional center align
* @param {Number} drawBorder - optional draw borders
*
* @attributes
* @param {String} tableName - optional id of the table to export
* @param {Boolean} isClassTableStructure - set to true when table should be exported by js-export-... classes
*
* @example
  <export-to-pdf align-center='true' table-name='reportTablePdf'></export-to-pdf>
  <div>
    <div class='js-export-report-name'>Test Report</div>
    <div class='js-export-subtitle'>Test Subtitle</div>
    <table id='reportTablePdf'>
      <thead>
        <th>Header</th>
        <th>Header 2</th>
      </thead>
      <tbody>
        <tr>
          <td>Table Cell</td>
          <td>Table Cell 2</td>
        </tr>
      </tbody>
    </table>
  </div>
*/

 (function () {
   'use strict';

   exportToPdf.$inject = ["$http", "$modal", "MICROSERVICES", "PATH", "localStorageService", "userDataGAService"];
   app.directive('exportToPdf', exportToPdf);

   function exportToPdf($http, $modal, MICROSERVICES, PATH, localStorageService, userDataGAService) {
     var pdfModal;
     var counter = 0;
     var directive = {
       restrict: 'E',
       template: '<button ng-click="doExport()" class="btn btn-default mod-export" ng-disabled="isDisabled">' +
                    '<div style="display: flex; align-items: center; height: 20px;">' +
                      '<span class="icon-export"></span>' +
                      '<span class="export-text"><span class="mod-settings-selector">Export to </span>PDF</span>' +
                    '</div>' +
                 '</button>',
       scope: {
         isDisabled: '=',
         alignCenter: '=?',
         drawBorder: '=?'
        // shouldDownload: '=?'
       },
       link: function (scope, element, attr) {
         pdfModal = $modal({
           scope: scope,
           show: false,
           templateUrl: PATH.common + 'templates/modal.shaded.html'
         });

         scope.doExport = doExport;
         scope.onHide = onHide;

         element.find('[data-toggle="tooltip"]').tooltip();

         function doExport() {
           var userInfo = localStorageService.get('userInfo');

           var data = parseTable(document.getElementById(attr.tableName || 'reportTable'), attr['isClassTableStructure']);
           var typeSelector = $('.js-export-report-name').length ? $('.js-export-report-name') : $('.breadcrumb li.active span');
           var reportType = typeSelector.text().replace('\n', '').trim();

           var reportInfo = generateReportInfo(data.columns, reportType);
           var fileName = $('[data-export-report-file-name]').length ? $('[data-export-report-file-name]').attr('data-export-report-file-name') : generateFileName(data.columns, reportType);

           data.fileName = fileName + '_' + userInfo.currentStore.id;
           data.reportInfo = reportInfo;
           data.companyName = userInfo.company.caption;
           data.storeAddress = userInfo.currentStore.contact && userInfo.currentStore.contact.address;
           data.alignCenter = scope.alignCenter;
           data.drawBorder = scope.drawBorder;

           $http.post(MICROSERVICES.pdf, data, { withCredentials: true })
            .then(function (res) {
              var src = MICROSERVICES.pdf + res.data.file;
              // if (scope.shouldDownload) {
              //   download(src);
              // } else {
              if (res.data.file.includes(userInfo.currentStore.id.toString())) {
                open(src, pdfModal, res.data);
              }
              // }
            })
            .then(function () {
              userDataGAService.sendGAEvent({
                eventCategory: 'exportPdfExcel',
                eventAction: 'exportToPdf',
                eventValue: 'pdf opened',
                additional: true
              });
            });
         }

         function onHide() {
           pdfModal.$promise.then(pdfModal.hide);
           angular.element(document.querySelector('.header-mat')).remove();
         }
       }
     };

     return directive;

     function open(src, modal, buffer) {
       function toBinaryString(data) {
         var ret = [];
         var len = data.length;
         var byte;
         for (var i = 0; i < len; i++) {
           byte = (data.charCodeAt(i) & 0xFF) >>> 0;
           ret.push(String.fromCharCode(byte));
         }

         return ret.join('');
       }
       $http.get(src, { withCredentials: true }).then(function (res) {
         var embed = angular.element('<embed></embed>');
         var data = toBinaryString(res.data);
         data = 'data:application/pdf;base64,' + btoa(data);
         embed.css({
           width: '100%',
           height: '100%'
         });
         embed.attr('src', data);
         embed.attr('type', 'application/pdf');
         modal.show();
         modal.$element.find('.modal-dialog').append(embed);
       }).catch(function (e) {
         if (counter < 3) {
           open(src, pdfModal);
           counter++;
         }
       });
     }

     function generateFileName(headers, reportType) {
       var dateRange = [],
         dateFormated,
         i;
       var reportTypeName = reportType.split(' ').join('_');

       for (i = 0; i < headers.length; i++) {
         dateFormated = '';
         dateFormated = getDateRange(headers[i].text.replace('\n', '').trim());
         if (dateFormated) dateRange.push(dateFormated);
       }

       if (dateRange.length > 1) {
         reportTypeName += '_' + dateRange[0] + '-' + dateRange.pop();
       } else if (dateRange.length) {
         reportTypeName += '_' + dateRange[0];
       }

       return reportTypeName;
     }

     function getDateRange(value, type) {
       var date;
       if (/[A-Za-z]+\s\d+/.test(value)) {
         if (type === 'title') {
           date = value;
         }
         else {
           date = moment(value, 'MMM YYYY').format('MMYY');
         }
         return date;
       } else if (/\d+\/\d+\/\d+/.test(value)) {
         if (type === 'title') {
           date = value;
         }
         else {
           date = moment(value, 'MM/DD/YY').format('MMDDYY');
         }
         return date;
       }
     }

     function generateReportInfo(headers, reportType) {
       var subtitle = jQuery('.js-export-subtitle').text();
       if (subtitle) {
         return reportType + ' ' + subtitle;
       }

       var dateRange = [],
         rangeName = ' ',
         dateFormated,
         i;

       for (i = 0; i < headers.length; i++) {
         dateFormated = '';
         dateFormated = getDateRange(headers[i].text.replace('\n', '').trim(), 'title');
         if (dateFormated) dateRange.push(dateFormated);
       }

       rangeName = dateRange[0] || '';
       if (dateRange.length > 1) {
         rangeName += ' - ' + dateRange.pop();
       } else if (!rangeName.length) {
         if (jQuery('[data-report-start-date]') && jQuery('[data-report-end-date]')) {
           var start = jQuery('[data-report-start-date]').attr('data-report-start-date');
           var end = jQuery('[data-report-end-date]').attr('data-report-end-date');
           rangeName += [start, end].join(' - ');
         } else {
           var start = jQuery('[data-type="custom-date-range-from"]');
           if (!start.length) {
             start = jQuery('[name="daterangepicker_start"]').last();
           }
           if (start.length) rangeName += start.val();

           var end = jQuery('[data-type="custom-date-range-to"]');
           if (!end.length) {
             end = jQuery('[name="daterangepicker_end"]').last();
           }
           if (end.length) rangeName += ' - ' + end.val();
         }
       }

       return reportType + ' ' + rangeName;
     }


     function parseTable(table, isClassTableStructure) {
       function clearContent(value) {
         return value.replace('\n', '', 'g').trim();
       }
       var data = [],
         headers = [],
         header, i, tableRow, rowData, j;

       var isTableView = $('.table-view').length;

       if (isTableView && !table.rows) {
         header = { cells: document.getElementsByClassName('table-view__header-cell') };

         var cells = $(table).find('.table-view__row-value');
         var rowsInAColumn = cells.length / header.cells.length;
         var rows = [];
         _.range(rowsInAColumn).forEach(function (i) {
           var row = [];
           _.range(header.cells.length).forEach(function (column) {
             row.push(cells[column * rowsInAColumn + i]);
           });
           rows.push({ cells: row });
         });

         var footerCells = $(table).find('.table-view__footer-value');
         if (footerCells.length) rows.push({ cells: footerCells });

         table.rows = rows;
         table.rows.unshift(header);
       } else if (isClassTableStructure) {
         header = { cells: document.getElementsByClassName('js-export-th') };
         table.rows = [].slice.call(document.getElementsByClassName('js-export-tr'));
         table.rows.unshift(header);
       } else {
         header = table.rows[0];
       }

       for (i = 0; i < header.cells.length; i++) {
         var headerStyle = window.getComputedStyle(header.cells[i]);
         var isLeftAlignHeader = headerStyle.textAlign === 'start' || headerStyle.textAlign === 'left';
         var headerPdf = {
           text: header.cells[i] ? clearContent(header.cells[i].textContent) : '',
           isLeftAlign: isLeftAlignHeader,
           ellipsize: header.cells[i].getAttribute('js-overflow-ellipsis') !== null
         };
         headers.push(headerPdf);
       }

       for (i = 1; i < table.rows.length; i++) {
         tableRow = table.rows[i];
         if (i > 1 && $(tableRow).find('td.break-td,td.category-head').length > 0) {
           data.push(['']);
         }
         if (!($(tableRow).text().replace('\n', '').trim() === '' || tableRow.classList.contains('no-js-export')) || isTableView) {
           if (isClassTableStructure && !isTableView) tableRow = { cells: tableRow.getElementsByClassName('js-export-td') };
           rowData = [];
           for (j = 0; j < header.cells.length; j++) {
             if (tableRow.cells[j]) {
               var cellStyle = window.getComputedStyle(tableRow.cells[j]);

               var fontWeight = cellStyle.fontWeight;
               var isBold = fontWeight === 'bold' || fontWeight > 400;
               var containsBold = false;
               if (tableRow.cells[j].firstElementChild) {
                 containsBold = tableRow.cells[j].firstElementChild.tagName === 'B';
                 if (tableRow.cells[j].firstElementChild.firstElementChild) {
                   containsBold = tableRow.cells[j].firstElementChild.firstElementChild.tagName === 'B';
                 }
               }

               var borders = [];
               var hasTopBorder = cellStyle.borderTopStyle !== 'none';
               var hasBottomBorder = cellStyle.borderBottomStyle !== 'none';

               if (hasTopBorder) borders.push('top');
               if (hasBottomBorder) borders.push('bottom');
               var isLeftAlignCell = cellStyle.textAlign === 'start' || cellStyle.textAlign === 'left';

               var cell = {
                 text: clearContent(tableRow.cells[j].textContent),
                 bold: (isBold || containsBold),
                 border: borders,
                 isLeftAlign: isLeftAlignCell
               };
               rowData.push(cell);
             } else {
               rowData.push('');
             }
           }
           data.push(rowData);
         }
       }
       return { columns: headers, data: data };
     }
   }
 }());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/exportToPdf.js